import * as React from 'react';
export const kakaoBankSvg = React.forwardRef(function kakaoBankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FFE300',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M22.03 16a5.978 5.978 0 0 0 2.72-5.007C24.75 7.683 22.047 5 18.715 5H8.599a.348.348 0 0 0-.349.347v21.305c0 .193.157.348.35.348h10.115c3.332 0 6.035-2.682 6.035-5.993a5.976 5.976 0 0 0-2.72-5.008v.002Zm-4.965 5.007h-1.9V10.993h1.9v10.014Z',
      fill: '#1E1E1E',
    }),
  );
});
kakaoBankSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var kakaoBank = {
  category: 'brand',
  colorable: false,
  name: 'kakaoBank',
  svg: kakaoBankSvg,
};
